import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Card, Button, Table, Typography } from "antd";

import { MemberRequestResponse } from "store/eligibility/actions";

import { ErrorResponse } from "utils/types";
import notifier from "utils/notifier";
import { formatDate, getDisplayCompanyId } from "utils/helpers";
import { UserRole } from "utils/enums";
import { MEMBER_ADDED_TEXT } from "utils/objects";

import RequestedMemberListComponentProps from "./Proptypes";

import styles from "./RequestedMemberList.module.scss";

const { Title } = Typography;

const RequestedMemberListComponent = (
  props: RequestedMemberListComponentProps
) => {
  const history = useHistory();
  const [requestMemberDataSource, setRequestMemberDataSource] = useState(
    [] as Object[]
  );

  const requestMemberColumns = [
    {
      title: "IPA",
      key: "RmiCompanyId",
      dataIndex: "RmiCompanyId",
      render: (text: string) => getDisplayCompanyId(text),
    },
    {
      title: "Member Name",
      key: "RmiLastName, RmiFirstName",
      dataIndex: "RmiLastName, RmiFirstName",
      render: (_: number, record: any) =>
        record.RmiLastName + ", " + record.RmiFirstName,
    },
    {
      title: "DOB",
      key: "RmiBirth",
      dataIndex: "RmiBirth",
      render: (_: number, record: any) =>
        formatDate(record.RmiBirth, "MM/DD/YYYY"),
    },
    {
      title: "Health Plan",
      key: "RmiHealthPlan",
      dataIndex: "RmiHealthPlan",
    },
    {
      title: "Health Plan Member ID",
      key: "RmiHPMemberId",
      dataIndex: "RmiHPMemberId",
      render: (_: string, record: any, __: number) => {
        if (record.IsMemberAdded === MEMBER_ADDED_TEXT) {
          return (
            <a
              onClick={() =>
                switchToEligibilityDetailPage(record.RmiHPMemberId)
              }
            >
              {record.RmiHPMemberId}
            </a>
          );
        } else return record.RmiHPMemberId;
      },
    },
    {
      title: "Requested On",
      key: "RmiCreatedDate",
      dataIndex: "RmiCreatedDate",
      render: (_: number, record: any) =>
        formatDate(record.RmiCreatedDate, "MM/DD/YYYY [@] h:mm A z"),
    },
    {
      title: "Status",
      key: "IsMemberAdded",
      dataIndex: "IsMemberAdded",
    },
  ];

  const getMemberRequest = () => {
    return props
      .getMemberRequest(sessionStorage.user_id)
      .then((data: MemberRequestResponse[]) => {
        setRequestMemberDataSource(data);
      })
      .catch((err: ErrorResponse) =>
        notifier.error(
          err.response.data.Message ||
            "Something went wrong, please contact a system administrator."
        )
      );
  };

  const switchToEligibilityDetailPage = (memberId: any) => {
    //According to legacy code
    const provider =
      sessionStorage.user_role === UserRole.CASE ||
      sessionStorage.user_role === UserRole.IPA
        ? "OTHER"
        : "PCP";
    let formData = {
      MemberId: memberId,
      Provider: provider,
      UserId: sessionStorage.user_id,
      CompanyId: sessionStorage.getItem("ipaGroup"),
    };
    return props
      .search(formData)
      .then((response: any) => {
        if (response.length > 0) {
          const memberSelected = response.find(
            (member: any) =>
              member.RmiCompanyId === formData.CompanyId &&
              member.RmiMembId === memberId
          );
          history.push({
            pathname: "/eligibility/member-detail",
            state: {
              eligibilityMemberInfo: memberSelected,
            },
          });
        } else {
          notifier.error(
            "No access. Please use eligibility to search for this member."
          );
        }
      })
      .catch((err: ErrorResponse) => {
        notifier.error(
          err?.response?.data?.Message ||
            "Something went wrong, please contact a system administrator."
        );
      });
  };

  useEffect(() => {
    getMemberRequest();
  }, []);

  return (
    <div
      className={`${styles["requested-member-list-component"]} flex-lg-wrap justify-content-start mb-3 ml-0 mt-3`}
    >
      <div className="row">
        <div className="col-lg-22 col-md-22">
          <Title level={3}>Requested Members</Title>
        </div>
        <div className="col-lg-2 col-md-2">
          <Button
            className={`${styles["requested-member-list-btn"]} ${styles["request-a-member-btn"]} ${styles["float-right"]}`}
            onClick={props.pageStartHandler}
          >
            Request a Member
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-24">
          <Card>
            <Table
              columns={requestMemberColumns}
              dataSource={requestMemberDataSource}
              pagination={false}
              loading={props.isFetchingMember}
              rowKey={"RmiUid"}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default RequestedMemberListComponent;
